import { Stack, Typography } from "@mui/material";

interface FreeStreamsHeroProps {
  title: string;
  subtitle: string;
}

const FreeStreamsHero = ({ title, subtitle }: FreeStreamsHeroProps) => {
  return (
    <Stack sx={{ pt: "160px", pb: "48px", alignItems: "center" }} spacing={3}>
      <Typography
        sx={{
          fontFamily: "Mulish",
          fontWeight: 900,
          fontSize: "56px",
          color: "primary.main",
          textAlign: "center",
          lineHeight: "64px",
          maxWidth: "765px",
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Mulish",
          fontWeight: 400,
          fontSize: "16px",
          color: "black",
          textAlign: "center",
        }}
      >
        {subtitle}
      </Typography>
    </Stack>
  );
};

export default FreeStreamsHero;
